import type { MessageResponse } from '@type/http';
import { Api } from '../config/api';
import type { ChatHistory } from '../types/ChatWindow';
import { getRequest } from './httpService';

/**
 * The `lastFetchedTimestamp` option is used to optimize message fetching by retrieving only the messages
 * that were sent after the last fetch. This avoids fetching the entire message history repeatedly,
 * reducing server load and improving performance, especially for users with large chat histories.
 */
export const getMessagesOfUser = async (
  userId: string,
  lastTimestamp?: number,
): Promise<ChatHistory[]> => {
  const params = lastTimestamp ? `?since=${lastTimestamp}` : '';

  const response = await getRequest<MessageResponse>(
    `${Api.REQUESTS.messages}/${userId}${params}`,
  );

  return response ? response.chatHistory : [];
};

/**
 * Extracts timestamp from a ChatHistory item
 * @param message The message to extract the timestamp from
 * @returns timestamp in milliseconds
 */
export const getMessageTimestamp = (message: ChatHistory): number => {
  return new Date(message.time).getTime();
};
